export const CHANNEL_CONFIG = {
  whatsapp: {
    label: "WhatsApp",
    color: "#25D366",
    initials: "W",
    deepLink: (handle) => `https://wa.me/${handle.replace(/\D/g, "")}`,
  },
  line: {
    label: "LINE",
    color: "#00B900",
    initials: "L",
    deepLink: (handle) => `line://ti/p/${handle.replace("@", "")}`,
  },
  telegram: {
    label: "Telegram",
    color: "#2AABEE",
    initials: "TG",
    deepLink: (handle) => `https://t.me/${handle.replace("@", "")}`,
  },
  instagram: {
    label: "Instagram",
    color: null,
    initials: "IG",
    deepLink: (handle) => `https://instagram.com/${handle.replace("@", "")}`,
  },
  facebook: {
    label: "Facebook",
    color: "#1877F2",
    initials: "FB",
    deepLink: (handle) => `https://facebook.com/${handle}`,
  },
  x_twitter: {
    label: "X / Twitter",
    color: "#000000",
    initials: "X",
    deepLink: (handle) => `https://x.com/${handle.replace("@", "")}`,
  },
  youtube: {
    label: "YouTube",
    color: "#FF0000",
    initials: "YT",
    deepLink: (handle) => `https://youtube.com/@${handle.replace("@", "")}`,
  },
  tiktok: {
    label: "TikTok",
    color: "#000000",
    initials: "TT",
    deepLink: (handle) => `https://tiktok.com/@${handle.replace("@", "")}`,
  },
  pinterest: {
    label: "Pinterest",
    color: "#E60023",
    initials: "P",
    deepLink: (handle) => `https://pinterest.com/${handle}`,
  },
  linkedin: {
    label: "LinkedIn",
    color: "#0077B5",
    initials: "in",
    deepLink: (handle) => `https://linkedin.com/in/${handle}`,
  },
  other: {
    label: "Other",
    color: "#64748B",
    initials: "?",
    deepLink: (handle) => (handle.startsWith("http") ? handle : null),
  },
}

export const DEFAULT_PLATFORMS = ["whatsapp", "line", "telegram"]
export const ALL_PLATFORMS = Object.keys(CHANNEL_CONFIG)
